export default {
  name: 'edit-comment',
  components: {},
  props: [],
  data () {
    return {
      comment: {},
      files: [],
      preview: [],
      errors: {},
      cmt: {
        content: ''
      },
      open_upload_image: false,
      index_image_destroys: [],
      btn_submit: false
    }
  },
  computed: {
  },
  mounted () {

  },
  methods: {
    showModel (comment) {
      this.$loading.start()
      this.$store.dispatch('FAQ/showCommentOfFAQ', {
        faq: {id: this.$route.params.faq_id}, comment
      }).then(res => {
        this.cmt = res
        this.preview = res.images_resize ? res.images_resize : []
        this.$refs.modal_edit.show()
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    update () {
      const data = new FormData()
      data.append('id', this.cmt.id)
      data.append('content', this.cmt.content)
      data.append('parent_id', this.cmt.parent_id)
      data.append('faq_id', this.$route.params.faq_id)
      data.append('_method', 'put')
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        data.append('img_path[' + i + ']', file)
      }
      for (var j = 0; j < this.index_image_destroys.length; j++) {
        let index = this.index_image_destroys[j]
        data.append('image_index[' + j + ']', index)
      }
      this.$loading.start()
      this.btn_submit = true
      this.$store.dispatch('FAQ/updateCommentOfFAQ', {faq: {id: this.$route.params.faq_id}, comment: data}).then(res => {
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        this.$refs.modal_edit.hide()
        this.cmt = {}
        this.files = []
        this.preview = []
        this.errors = {}
        this.$loading.complete()
        this.btn_submit = false
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
        this.btn_submit = false
      })
    },
    openUploadImage () {
      this.open_upload_image = !this.open_upload_image
    },
    change (event) {
      this.open_upload_image = false
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.files.push(this.$refs.files.files[i])
        let reader = new FileReader()
        reader.onload = (event) => {
          // console.log(event)
          this.preview.push(event.target.result)
        }
        reader.readAsDataURL(this.$refs.files.files[i])
      }
    },
    remove (index) {
      this.files.splice(index, 1)
      this.preview.splice(index, 1)
      this.index_image_destroys.push(index)
      delete this.errors['images.'+index]
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/faq/detail/comment/edit-comment/edit-comment.js